
<template>
  <div>
    <v-avatar class="ma-3" :color="image_to_show? '' :'secondary'" :size="img_size">
      <v-icon v-if="!image_to_show" size='58' dark>mdi-account</v-icon>
      <v-img v-if="image_to_show" :src="image_to_show" style="border: 0.2px solid #eee;"/>
    </v-avatar>
    <dialog-edit-logo v-if="preview" :can_edit="can_edit"></dialog-edit-logo>

  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import DialogEditLogo from './DialogEditLogo.vue'

export default {
  components: { DialogEditLogo },
  name: 'ShowLogo',
  props: {
    can_edit: {
      type: Boolean,
      default: true
    },
    preview:{
      type: Boolean,
      default: true
    },
    image_url:{
      type: String,
      default: null
    },
    img_size:{
      type: String,
      default: '120'
    }
  },
  data() {
    return {
      key: null,
    }
  },
  methods: {
    ...mapActions({
      // function: 'Module/action'
    })
  },
  computed: {
    image_to_show(){
      let img = null;
      if (this.file_local_url) {
        img = this.file_local_url
      } else if (this.$route.name == 'MyCompanySettings' && this.activeCompany && this.activeCompany.logo_url){
        img = this.activeCompany.logo_url
      } else if (this.$route.name == 'Account' && this.profile && this.profile.avatar_url){
        img = this.profile.avatar_url
      }else if(this.$route.name == 'RequestNegotiation'){
        img = this.image_url
      }
      return img;
    },
    ...mapState({
      activeCompany: state => state.App.activeCompany,
      profile: state => state.User.user
    })
  },
  watch: {
    data(nv,ov) {
      if (nv){
      } else if (nv == false){
      }
    }
  },
}
</script>

<style scoped>

</style>